var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countdownText)?_c('div',{staticClass:"count-down"},[_c('span',{staticClass:"text"},[_vm._v("仅剩 ")]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.countdownText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }